import { forwardRef } from 'react';
import type { ButtonProps } from 'antd';
import { StyledButton } from './components/StyledButton';

export type ButtonAntProps = Pick<
  ButtonProps,
  | 'id'
  | 'type'
  | 'size'
  | 'children'
  | 'htmlType'
  | 'disabled'
  | 'loading'
  | 'icon'
  | 'onClick'
  | 'style'
  | 'form'
  | 'block'
  | 'danger'
  | 'ghost'
  | 'href'
  | 'target'
>;

// AntdButton lose the ability to use ref once used with styled components, so we need to forward it
export const Button = forwardRef<HTMLButtonElement, ButtonAntProps>((props, ref) => {
  return <StyledButton {...props} ref={ref} />;
});

Button.displayName = 'Button';
